
const ModelViewItem = ({dataView , dataDisplay }) => {

    return(
       
                        
        <div className="form-group cassandra-form-group">
            <label>{dataDisplay}</label>
            <h3  className="form-control cassandra-form-control">{dataView}</h3>
        </div>

                           
            
    );

};
export default ModelViewItem;
